import { configureStore } from '@reduxjs/toolkit';

import { usuarioSlice } from './slices/usuario/usuarioSlice';
import { cursoSlice } from './slices/curso/cursoSlice';
import { moduloSlice } from './slices/modulo/moduloSlice';
import { bloqueSlice } from './slices/bloque/bloqueSlice';
import { seccionSlice } from './slices/seccion/seccionSlice';

import { noticiaSlice } from './slices/noticia/noticiaSlice';


import { rutaSlice } from './slices/ruta/rutaSlice';

import { ayudantiaSlice } from './slices/ayudantia/ayudantiaSlice';
import { ejercicioSlice } from './slices/ejercicio/ejercicioSlice';

import { diapositivaSlice } from './slices/seccion-diapositiva/seccionDiapositivaSlice';
import { seccionEjercicioSlice } from './slices/seccion-ejercicio';

import { edicionSlice } from './slices/edicion/edicionSlice';


export const store = configureStore({
  reducer: {
    usuario: usuarioSlice.reducer,
    curso: cursoSlice.reducer,
    modulo: moduloSlice.reducer,
    bloque: bloqueSlice.reducer,
    seccion: seccionSlice.reducer,

    ruta: rutaSlice.reducer,
    
    noticia: noticiaSlice.reducer,
    ayudantia: ayudantiaSlice.reducer,
    ejercicio: ejercicioSlice.reducer,

    diapositiva: diapositivaSlice.reducer,
    seccionEjercicio: seccionEjercicioSlice.reducer,

    edicion: edicionSlice.reducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// export type RootState = typeof store.getState;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;